import React from 'react';
import './TitleCard.css';

const TitleCard = ({img}) => {
  return(
    <div className="titleCard">
      <img 
        className="svg" 
        src={img} 
        alt={img}
        onError={(e) => e.target.src = null}
      />
    </div>
  )
}

export default TitleCard;